import { MaterialDialog } from '@shared/components/Dialogs';
import { sxStyle } from './styles';
import { Box, Button, Typography } from '@mui/material';

const ConditionsDialog = ({ openModal, handleCloseModal, aceptCondition }) => {
  return (
    <MaterialDialog
      isOpen={openModal}
      handleIsOpen={handleCloseModal}
      actionsButton={false}
      maxWidth="sm"
    >
      <img
        src="https://repostatic.blob.core.windows.net/static/Z_SYSTEM/20220218A/SITIOS/GIT/empresa/img/nav/logo-git.png"
        width={'140px'}
      />
      <Box sx={sxStyle.barra}></Box>
      <Typography variant="h6" sx={sxStyle.titleBaner}>
        CONDICIONES DE GESTIÓN DE PAGO CON TARJETAS DE CRÉDITO Y OTROS MEDIOS.
      </Typography>

      <p>
        Cuando Usted envía una Solicitud de Compra a través de la Plataforma de{' '}
        <strong>GIT S.R.L</strong>, nos autoriza a gestionar su reserva y a
        cursar el/los respectivo/s cargo/s a su cuenta o tarjeta.{' '}
      </p>
      <p>
        El buen término de la gestión de la reserva y/o la confirmación de la
        compra, dependen del pago íntegro del precio de todos los Servicios
        Turísticos contratados. Mientras no se confirme el pago total de la
        reserva, la Solicitud de Compra quedará en suspenso y podría ser
        cancelada por el Proveedor.
      </p>
      <p>
        La confirmación definitiva de los Servicios Turísticos y precios
        respectivos se producirá con la emisión de el/los tickets/s
        electrónico/s o el envío del voucher - lo que aplique - y su
        facturación. La emisión del ticket electrónico o el voucher - lo que
        aplique - da fe de la aceptación de las condiciones del Proveedor y la
        celebración del contrato suscrito entre el Proveedor y la persona cuyo/s
        nombre/s aparece/n en dicho ticket electrónico y/o voucher. Si la
        Solicitud de Compra quedara sujeta a confirmación -circunstancia que le
        será informada en el primer correo electrónico que reciba- los valores
        pagados antes de la confirmación serán recibidos bajo concepto de
        reserva. Si finalmente su Solicitud de Compra fuera rechazada por
        cualquier motivo (por ejemplo, por saldo insuficiente en su tarjeta de
        crédito, por falta de disponibilidad, por variación en la tarifa, etc.),
        GIT S.R.L procederá a informarle las opciones disponibles para el caso
        en que Ud. desee insistir en la compra o reserva o, a su requerimiento,
        le devolverá los importes abonados.
      </p>
      <p>
        Cuando Usted reserva uno o más Servicios Turísticos a través de{' '}
        <strong>GIT S.R.L</strong>, Usted debe abonar (i) el precio o tarifa
        fijada por el Proveedor, (ii) los impuestos, tasas y/o percepciones
        fiscales aplicables al Servicio Turístico y, en caso de corresponder,
        (iii) el cargo de gestión por el servicio de intermediación de{' '}
        <strong>GIT S.R.L</strong> (el Cargo de Gestión). Los medios y formas de
        pago disponibles para cada Servicio Turístico son los informados en la
        Plataforma en forma previa a ingresar su Solicitud de Compra.
      </p>
      <p>
        Tenga presente que cuando Usted informa los datos de su cuenta o tarjeta
        de crédito (mediante el formulario disponible en la Plataforma), y luego
        acepta o confirma la operación, está autorizándonos a efectuar los
        cargos por: (i) la tarifa del Servicio Turístico (ii) los impuestos,
        tasas y/o percepciones fiscales que pudieran corresponder y (iii)
        nuestros Cargos de Gestión - de corresponder-. Si Usted efectúa una
        reserva en opción cuotas y/o mediante una tarjeta de crédito, tenga
        presente que:
      </p>
      <p>
        El Cargo de Gestión de GIT S.R.L (de corresponder) podría aplicarse
        íntegro en la primera cuota a pesar de que haya elegido la opción de
        pago en cuotas para el resto del precio o tarifa
      </p>
      <p>
        Los intereses y/o impuestos que pudieran generar los pagos en cuotas se
        suman al precio o tarifa propuesto para el servicio, y dicho total se
        divide por la cantidad de cuotas seleccionada para el pago
      </p>
      <p>
        De realizar una cancelación con posterioridad a la compra, siempre que
        las condiciones particulares del Servicio Turístico lo permitan, GIT
        S.R.L no reintegrará ni se hará responsable de los intereses que la
        transacción original haya generado, en tanto GIT S.R.L no percibe dichos
        intereses.
      </p>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button sx={sxStyle.btnAceptar} onClick={() => aceptCondition()}>
          Aceptar
        </Button>
      </div>
    </MaterialDialog>
  );
};

export default ConditionsDialog;
